"use strict";

exports.__esModule = true;
var _Report = require("./Report");
Object.keys(_Report).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Report[key]) return;
  exports[key] = _Report[key];
});